const options = {
  5: "bg-rose-100/5",
  10: "bg-rose-100/10",
  25: "bg-rose-100/25",
  50: "bg-rose-100/50",
  75: "bg-rose-100/75",
  90: "bg-rose-100/90",
  100: "bg-rose-100",
};

const from = {
  5: "from-rose-100/5",
  10: "from-rose-100/10",
  25: "from-rose-100/25",
  50: "from-rose-100/50",
  75: "from-rose-100/75",
  90: "from-rose-100/90",
  100: "from-rose-100",
};

export default function getBackgroundRose100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
